/** Browser UI language mapped to supported app locales (de | en). */
export function inferUiLocaleFromNavigator(): 'de' | 'en' {
  if (!import.meta.client) return 'de'
  const primary = (navigator.language || 'de').split('-')[0]?.toLowerCase()
  return primary === 'en' ? 'en' : 'de'
}
